import { Pipe, PipeTransform } from '@angular/core';
import { TitleCasePipe } from '@angular/common';

@Pipe({name: 'separateAndApplyTitleCaseToCamelcase'})
export class SeparateAndApplyTitleCaseToCamelcase implements PipeTransform {
  constructor(private titleCasePipe: TitleCasePipe) {}

  transform(cc: string): string {
    // seperates the camel case (cc arg) at the upper-case letters
    let text = cc.replace(/([a-z])([A-Z])/g, '$1 $2');
    // applies titleCasePipe to the text, capitalising the first letter of each word
    return this.titleCasePipe.transform(text);
  }
}